<template>
  <div></div>
</template>

<script>
var intervalRef = void 0;
var notifyDisplayed = false;
import snackbar from "@/plugins/snackbar";
import AccountUsers from "@/api/account_users";
import ReportDownloads from "@/api/report_downloads";

export default {
  name: "Polling",

  mounted() {
    this.refreshStatus(); // 刷新权限和设置
    this.getReportDownloadsFromAPI(); // 刷新是否有新的报表可下载
    intervalRef = setInterval(() => {
      this.refreshStatus(); // 刷新权限和设置
      if (!notifyDisplayed) {
        // ↑显示通知的内容在上一条通知显示过程中不再查询
        this.getReportDownloadsFromAPI(); // 刷新是否有新的报表可下载
      }
    }, 10 * 60 * 1000);// 10分钟刷新一次
  },

  methods: {
    refreshStatus() {
      AccountUsers.my(true);
    },
    getReportDownloadsFromAPI() {
      if (!this.$permission.permissionAllow("ReportDownloads", "index")) return; //无权限则不访问
      if (!this.$permission.permissionAllow("ReportDownloads", "webRead"))
        return; //无权限则不访问
      ReportDownloads.fetch(
        {
          status: 1, // 仅查询已生成的
          web_read_flg: 0, //仅查询未读过的
          limit: 1, // 只查最近1条
        },
        true
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            var record = response.data.report_download_records[0];// 只显示最近1条
            if (!record) return; // 没有记录则不处理
            notifyDisplayed = true;
            snackbar.success(record.report_name, 3000);// 显示通知，3秒自动关闭
            var intervalAutoReadRef = setInterval(() => {
              ReportDownloads.read(record.id);
              notifyDisplayed = false;
              clearInterval(intervalAutoReadRef);
            }, 3000); // 3秒后自动标记为已读
          }
        }.bind(this)
      );
    },
  },

  beforeDestroy() {
    clearInterval(intervalRef);
    intervalRef = void 0;
  },
};
</script>